import React from "react";

import { useLocation } from 'react-router-dom'

import MainMenu from "../MainMenu/MainMenu";

import styles from "./Header.module.css";

const LocationTitles: any = {
  "/zonic": "Zonic",
  "/imp": "Impressum",
  "/avatar": "Joker's Cap",
}
function getTitle(path:string){
  for (const key in LocationTitles) {
    if (Object.prototype.hasOwnProperty.call(LocationTitles, key)) {
      const element = LocationTitles[key];
      if(path.startsWith(key)){
        return element;
      }
    }
  }
}


export default function Header() {
  const location = useLocation();
  const [title, setTitle] = React.useState("");
  React.useEffect(() => {
    setTitle(getTitle(location.pathname));
  }, [location.pathname]);

  return (
    <div className={styles.Header}>
        <div className={'instruction-info-field'}>
          <div className={'instruction-info-back'} style={{borderRadius: 4, left: 1}}>
            <p style={{top:-18, left:70}}>Menü</p>
          </div>
          <MainMenu  />
        </div>
      <h2 className={styles.Title}>{title}</h2>
    </div>
  );
}